var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 6h-7.5c-.2 0-.6.1-.7.3l-4.5 4.4-4.4-4.5c-.3-.1-.5-.2-.8-.2H2C1 6 .5 7.1 1.3 7.8l4.9 4.9v21.2c0 .6.5 1 1 1h25.4c.6 0 1-.5 1-1V12.7l4.9-4.9c.9-.8.4-1.8-.6-1.8zm-6.2 26.8h-5.4V13.3h5.4v19.5zm-3.9-21.6L30.9 8h4.5l-3.1 3.1h-4.5zm-3.6 21.6H8.4V13.3h15.9l-.1 19.5zM19.6 8.1l3.1 3.1h-15l-3-3.1h14.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 28.6v1.6c0 .6.5 1 1 1 .6 0 1-.5 1-1v-1.6c.5.6 1.1.3 1.5 0 .4-.4.4-1 0-1.5l-1.8-1.8c-.4-.4-1-.4-1.5 0l-1.8 1.8c-.4.4-.4 1 0 1.5.4.4 1.2.4 1.6 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpack);
export default __webpack_public_path__ + "static/media/unpack.bd3be24d.svg";
export { ForwardRef as ReactComponent };